import { render, staticRenderFns } from "./AppstorePopup.vue?vue&type=template&id=26c4f5a6&scoped=true&"
import script from "./AppstorePopup.vue?vue&type=script&lang=js&"
export * from "./AppstorePopup.vue?vue&type=script&lang=js&"
import style0 from "./AppstorePopup.vue?vue&type=style&index=0&id=26c4f5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c4f5a6",
  null
  
)

component.options.__file = "AppstorePopup.vue"
export default component.exports